import { Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";
import PageEnelX from "./pages/PageEnelX";
import PageNotFound from "../../util/page/PageNotFound";
import Loading from "./component/Loading";
import PagePayments from "./pages/PagePayments";
import PageInvoices from "./pages/PageInvoices";
import PageRoyalties from "./pages/PageRoyalties";
import PageMobilityStore from "./pages/PageMobilityStore";
import PrintoutWizard from "./pages/mobilitystore/pages/PrintoutWizard";
import PageCluster from "./pages/PageCluster";
import RoyaltiesPrintoutWizard from "./pages/royalties/pages/RoyaltiesPrintoutWizard";
import PagePayableInvoices from "./pages/PagePayableInvoices";
import PageCashback from "./pages/PageCashback";
import CashbackThresholdWizard from "./pages/cashback/pages/CashbackThresholdsWizard";
import PageSddMandates from "./pages/PageSddMandates";
import PageSddCollections from "./pages/PageSddCollections";
import PageIntermediaries from "./pages/PageIntermediaries";
import IntermediariesPrintoutWizard from "./pages/intermediaries/pages/IntermediariesPrintoutWizard";
import ReportPreview from "./pages/intermediaries/sections/ReportPreview";
import PageFuelCards from "./pages/PageFuelCards";
import PageRegistryFuelCards from "./pages/PageRegistryFuelCards";
import Refuelling from "./pages/refuelling";
import PageEToll from "./pages/PageEToll";

const FinanceMain = () => {

    return (
        <Routes>
            <Route path="/enel-x/*" element={
                <RecoilRoot key='finance.enel-x'>
                    <Loading/>
                    <PageEnelX/>
                </RecoilRoot>
            }/>
            <Route path="/e-toll/*" element={
                <RecoilRoot key='finance.e-toll'>
                    <Loading/>
                    <PageEToll/>
                </RecoilRoot>
            }/>
            <Route path="/payments/*" element={
                <RecoilRoot key='finance.payments'>
                    <Loading/>
                    <PagePayments/>
                </RecoilRoot>
            }/>
            <Route path={"payments/sdd/mandates/*"} element={
                <RecoilRoot key={"finance.sdd.mandates"}>
                    <Loading/>
                    <PageSddMandates/>
                </RecoilRoot>
            } />
            <Route path={"payments/sdd/collections/*"} element={
                <RecoilRoot key={"finance.sdd.collections"}>
                    <Loading />
                    <PageSddCollections />
                </RecoilRoot>
            } />
            <Route path="/cashback/*" element={
                <RecoilRoot key='finance.cashback'>
                    <Loading/>
                    <PageCashback/>
                </RecoilRoot>
            }/>
            <Route path="/cashback/threshold-wizard" element={
                <RecoilRoot key='finance.cashback'>
                    <CashbackThresholdWizard/>
                </RecoilRoot>
            }/>
            <Route path="/invoices/*" element={
                <RecoilRoot key='finance.invoices'>
                    <Loading/>
                    <PageInvoices/>
                </RecoilRoot>
            }/>
            <Route path="/invoices-payable/*" element={
                <RecoilRoot key='finance.payable-invoices'>
                    <Loading/>
                    <PagePayableInvoices/>
                </RecoilRoot>
            }>
            </Route>
            <Route path="/royalties/*" element={
                <RecoilRoot key='finance.royalties'>
                    <Loading/>
                    <PageRoyalties/>
                </RecoilRoot>
            }/>
            <Route path="/royalties/printouts-wizard" element={
                <RecoilRoot key='finance.royalties'>
                    <RoyaltiesPrintoutWizard/>
                </RecoilRoot>
            }/>
            <Route path="/mobility-store/*" element={
                <RecoilRoot key='finance.mobility-store'>
                    <Loading/>
                    <PageMobilityStore/>
                </RecoilRoot>
            }/>
            <Route path="/mobility-store/printouts-wizard" element={
                <RecoilRoot key='finance.mobility-store'>
                    <Loading/>
                    <PrintoutWizard/>
                </RecoilRoot>
            }/>
            <Route path="/clusters/*" element={
                <RecoilRoot key='finance.clusters'>
                    <Loading/>
                    <PageCluster/>
                </RecoilRoot>
            }/>
            <Route path="*" element={
                <PageNotFound/>
            }/>
            <Route path="/intermediaries/*" element={
                <RecoilRoot key='finance.intermediaries'>
                    <Loading/>
                    <PageIntermediaries/>
                </RecoilRoot>
            }/>
            <Route path="/intermediaries/printouts-wizard" element={
                <RecoilRoot key='finance.intermediaries'>
                    <Loading/>
                    <IntermediariesPrintoutWizard/>
                </RecoilRoot>
            }/>
            <Route path="/intermediaries/report/:id" element={
                <RecoilRoot key='finance.intermediaries'>
                    <Loading/>
                    <ReportPreview/>
                </RecoilRoot>
            }
            />
            <Route path="/fuelcards/*" element={
                <RecoilRoot key='finance.fuelcards'>
                    <Loading/>
                    <PageFuelCards/>
                </RecoilRoot>
            }/>
             <Route path="/refuelling/*" element={
                <RecoilRoot key='finance.refuelling'>
                    <Loading/>
                    <Refuelling/>
                </RecoilRoot>
            }/>
            <Route path="/registryFuelcards/*" element={
                <RecoilRoot key='finance.registryFuelCards'>
                    <Loading/>
                    <PageRegistryFuelCards/>
                </RecoilRoot>
            }/>
        </Routes>
    );
}

export default FinanceMain;